import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import API from "../../API/newIndex";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { parentNavigate } from "../../controllers/ParentNavigate";
import LightHouseData from "../Main/LightHouseData";
import Notification from "../Notification";
const GoogleRealTime = () => {
  const isDarkMode = localStorage.getItem("dark-mode");
  const [countryName, setCountryName] = useState([]);
  const [activeUser, setActiveUser] = useState([]);
  const isMounted = useRef(true);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const GetRealTimeChart = async () => {
    if (isMounted.current) {
      try {
        const ApiCall = await API({
          url: `/admin/googleanalytics/runRealtimeReport`,
          method: "get",
        });
        if (ApiCall.status === 200 || ApiCall.status === 304) {
          const result = ApiCall?.data;
          setCountryName(result?.responcedata?.map((row) => row.dimensionValues[1].value));
          setActiveUser(result?.responcedata?.map((row) => row.metricValues[0].value));
        }
      } catch (error) {
        setIsNotification(true);
        setNotificationMsg(error);
        setSeverity("error");
      }
    }
  };
  useEffect(() => {
    GetRealTimeChart();
    window.dispatchEvent(new Event("resize"));

    return () => {
      isMounted.current = false;
    };
  }, []);

 const options = {

  chart: {
    id: "apexchart-example",
    type: "line",
    width: "100%",

    // ✅ background
    background: isDarkMode ? "#333333" : "#ffffff",

    // ✅ text color
    foreColor: isDarkMode ? "#e5e7eb" : "#374151",

    toolbar: {
      show: false,
    },
  },

  theme: {
    mode: isDarkMode ? "dark" : "light",
  },

  xaxis: {
    categories: countryName,

    labels: {
      style: {
        colors: isDarkMode ? "#e5e7eb" : "#374151",
      },
    },
  },

  yaxis: {

    title: {
      text: "Active Users",

      style: {
        color: isDarkMode ? "#e5e7eb" : "#374151",
      },
    },

    labels: {
      style: {
        colors: isDarkMode ? "#e5e7eb" : "#374151",
      },
    },
  },

  grid: {
    borderColor: isDarkMode ? "#555555" : "#e5e7eb",
  },

  dataLabels: {
    enabled: false,
  },

  stroke: {
    curve: "smooth",
    width: 3,
  },

  colors: isDarkMode
    ? ["#60a5fa"]
    : ["#2563eb"],

  tooltip: {
    theme: isDarkMode ? "dark" : "light",
  },

};
  const series = [
    {
      name: "Active Users",
      data: activeUser,
    },
  ];
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto overflow-x-hidden pb-[64px] p-[20px]">
        <div className="flex items-center space-x-2 pb-[20px]">
          <button
            onClick={(e) => {
              e.preventDefault();
              parentNavigate("/dashboard");
            }}
            className="back-arrow"
          >
            <ArrowLeft />
          </button>
          <div>
            <Breadcrumbs
              crumbs={[
                { name: t("lang_dashboard"), path: `/dashboard` },
                { name: t("lang_Google_Real_Time_Report"), path: "/google-analytics/realtime" },
              ]}
            />
            <h4 className="text-xl md:text-2xl font-semibold text-primary">
              {t("lang_Google_Real_Time_Report")}
            </h4>
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-1">
          <div className="secondary-bg-color border mb-4 main-border-color overflow-x-auto overflow-y-hidden">
            <h6 className="border-b main-border-color py-2 px-4 text-base font-medium">
              {t("lang_Real_Time_Report")}
            </h6>
            <div className="py-5 max-w-full overflow-x-auto">
              <Chart options={options} series={series} type="line" height={300} />
            </div>
          </div>
        </div>
        <LightHouseData />
      </div>
    </>
  );
};
export default GoogleRealTime;
